"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sticky = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
function Sticky(_a) {
    var { render: Elem, offset: offsetProp = 0 } = _a, props = __rest(_a, ["render", "offset"]);
    const stickyRef = (0, react_1.useRef)(null);
    const [sticky, setSticky] = (0, react_1.useState)(false);
    const initialTop = (0, react_1.useRef)();
    const offset = (0, react_1.useRef)(offsetProp);
    const handleScroll = (0, react_1.useCallback)(() => {
        requestAnimationFrame(() => {
            if (!stickyRef.current || typeof initialTop.current !== 'number') {
                return;
            }
            setSticky(document.body.scrollTop + document.documentElement.scrollTop >
                initialTop.current + offset.current);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        if (!stickyRef.current) {
            throw new Error('Sticky: missing stickyRef.');
        }
        initialTop.current = getPageTop(stickyRef.current);
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);
    return (0, jsx_runtime_1.jsx)(Elem, Object.assign({}, props, { sticky, stickyRef }));
}
exports.Sticky = Sticky;
function getPageTop(elem) {
    const isFixed = window.getComputedStyle(elem).getPropertyValue('position') === 'fixed';
    return isFixed
        ? 0
        : elem.getBoundingClientRect().top +
            (document.body.scrollTop + document.documentElement.scrollTop);
}
